import JsSIP from 'jssip';
import Logger from "./logger.service";
import { store } from "../context/store";
import { setSIPConnectingStatus, setSIPConnectionStatus, setSipDisconnectPause } from "../context/toolbarSlice";
import { getAgentData, getRoleStatus, isChatsPresent, isSettingEnabled } from "./util";
import { showInfoNotification } from '../components/common/NotiService';
import { setPauseReason } from '../context/timerSlice';
import { pauseAgent, releaseAgent } from './webEventHandlers';
import { AGENT_STATE, MODES } from '../constants';
import AudioDeviceHandler from './AudioDeviceHandler';
import WSocketService from './websocket.service';

const sipService = (function () {
    let services = {}
    let agentSIP = null;
    let call = null;
    let callRing;
    let callAnsweredBeep;
    let audioDeviceHandler = null;
    let remoteAudioElement = null; // Keep reference to audio element

    services.isSIPEnabled = false;
    services.loadSIP = function () {
    let agentLoginDetails = getAgentData();

        if (isSettingEnabled("SOFT_PHONE_FOR_SIP")) {
            Logger.info('[WebRTC]', "Sip not loading because Soft phone for sip enabled");
            return
        }

        if (agentSIP && agentSIP.transport && (agentSIP.transport.isConnected() || agentSIP.transport.isConnecting())) {
            Logger.info('[WebRTC]', 'Loading SIP skipped: SIP transport already connected=' + agentSIP.transport.isConnected() + ' connecting=' + agentSIP.transport.isConnecting());
            return;
        }

        services.isSIPEnabled = agentLoginDetails.isSip;
        if (services.isSIPEnabled) {
            let extension = agentLoginDetails.phoneNumber;
            let port = agentLoginDetails.params.SIP_URL.split(":")[1];
            let URL = agentLoginDetails.params.SIP_URL.split(":")[0];
            Logger.info('[WebRTC]', `Loading SIP with Extension=${extension}, SIP_URL=${agentLoginDetails?.params?.SIP_URL}`
);
            var socket = new JsSIP.WebSocketInterface("wss://" + agentLoginDetails.params.SIP_URL + (!port ? ":442" : ""));
            var configuration = {
                sockets: [socket],
                uri: "sip:" + extension + "@" + URL,
                'password': extension,
                'registrar_server': "sip:" + URL,
                'authorization_user': extension,
                'session_timers': false
            };
            agentSIP = new JsSIP.UA(configuration);
            agentSIP.start();
            audioDeviceHandler = new AudioDeviceHandler(agentSIP);

            agentSIP.on("connecting", function (e) {
                Logger.info('[WebRTC]', "Connecting to  sip...");
                store.dispatch(setSIPConnectingStatus(true));
            });

            agentSIP.on('connected', function (e) {
                Logger.info('[WebRTC]', "received sip connected event");
                handlesipConnection();

            });
            agentSIP.on('disconnected', function (e) {
                Logger.info('[WebRTC]', "received sip disconnected event", JSON.stringify(e));
                sipService.stopSIP();
                sipService.clearSIP();
                store.dispatch(setSIPConnectionStatus(false));
                store.dispatch(setSIPConnectingStatus(false));
                  startSipReconnectRetry();
                // handleSipDisconnect("SIP disconnected");
            });
            agentSIP.on('registered', function (e) {
                Logger.info('[WebRTC]', 'SIP Registered');
            });

            agentSIP.on('registrationFailed', function (e) {
                Logger.error('[WebRTC]', 'SIP Registration Failed', JSON.stringify(e));
                sipService.stopSIP();
                // sipService.clearSIP();
                store.dispatch(setSIPConnectionStatus(false));
                store.dispatch(setSIPConnectingStatus(false));
                //  handleSipDisconnect("SIP UnRegistered");
            });
            //new incoming and outgoing calls
            agentSIP.on('newRTCSession', function (e) {
                call = e.session;
                Logger.info('[WebRTC]', 'newRTCSession: originator=' + e.originator + ' callId=' + (call.id || 'unknown') + ' direction=' + (call.direction || 'unknown'));

                call.on('accepted', function (e) {
                    setCallanweredBeep();
                    Logger.info('[WebRTC]', 'Call accepted, status=' + call.status);
                });
                call.on('progress', function (e) {
                    setRingtone();
                    Logger.info('[WebRTC]', 'Call in progress, status=' + call.status + ' originator=' + e.originator);
                    handleSipAutoAnswer(false);
                });
                call.on('confirmed', function (e) {
                    setRingtone('pause');
                    Logger.info('[WebRTC]', 'Call confirmed, status=' + call.status);
                    ensureAudioContextActive();
                });
                call.on('ended', function (e) {
                    setRingtone('pause');
                    Logger.info('[WebRTC]', 'Call ended, cause=' + e.cause + ' originator=' + e.originator);
                    cleanupAudioElement();
                    AudioDeviceHandler.releaseMicrophone(call);
                });
                call.on('failed', function (e) {
                    setRingtone('pause');
                    Logger.error('[WebRTC]', 'Call failed, cause=' + e.cause + ' originator=' + e.originator);
                    cleanupAudioElement();
                    AudioDeviceHandler.releaseMicrophone(call);
                });
                call.on("sdp", function (e) {
                    Logger.info('[WebRTC]', 'SDP event: originator=' + e.originator + ' type=' + e.type);
                    Logger.info('[WebRTC]', 'SDP input:\n' + e.sdp);
                    const modified = setSdp(e.sdp);
                    Logger.info('[WebRTC]', 'SDP output:\n' + modified);
                    e.sdp = modified;
                });

                call.on("peerconnection", function (data) {
                    const peerconnection = data.peerconnection;
                    Logger.info('[WebRTC]', 'Peerconnection created, signalingState=' + peerconnection.signalingState + ' iceGatheringState=' + peerconnection.iceGatheringState + ' iceConnectionState=' + peerconnection.iceConnectionState);

                    peerconnection.addEventListener('signalingstatechange', function () {
                        Logger.info('ICE signalingState changed: ' + peerconnection.signalingState);
                    });
                    peerconnection.addEventListener('icegatheringstatechange', function () {
                        Logger.info('ICE gatheringState changed: ' + peerconnection.iceGatheringState);
                    });
                    peerconnection.addEventListener('iceconnectionstatechange', function () {
                        Logger.info('ICE connectionState changed: ' + peerconnection.iceConnectionState);
                    });
                    peerconnection.addEventListener('connectionstatechange', function () {
                        Logger.info('PeerConnection state changed: ' + peerconnection.connectionState);
                    });
                    peerconnection.addEventListener('icecandidate', function (event) {
                        if (event.candidate) {
                            Logger.info('ICE candidate generated: ' + event.candidate.candidate);
                        } else {
                            Logger.info('ICE candidate gathering complete (null candidate)');
                        }
                    });
                    peerconnection.addEventListener('icecandidateerror', function (event) {
                        Logger.error('ICE candidate error: errorCode=' + event.errorCode + ' errorText=' + event.errorText + ' url=' + event.url + ' address=' + event.address + ' port=' + event.port);
                    });

                    peerconnection.addEventListener('track', function (event) {
                        if (event.streams && event.streams[0]) {
                            Logger.info('Received remote audio track');
                            setupRemoteAudio(event.streams[0]);
                        }
                    });
                    // Fallback for older browsers/implementations
                    if (peerconnection.onaddstream !== undefined) {
                        peerconnection.onaddstream = function (e) {
                            Logger.info('Call Audio stream (legacy)');
                            setupRemoteAudio(e.stream);
                        }
                    }
                });
            });
        }
    }
    // Safari-specific audio context handling
    function ensureAudioContextActive() {
        if (window.AudioContext || window.webkitAudioContext) {
            const AudioContext = window.AudioContext || window.webkitAudioContext;
            const audioContext = new AudioContext();

            if (audioContext.state === 'suspended') {
                audioContext.resume().then(() => {
                    Logger.info('Audio context resumed');
                }).catch(err => {
                    Logger.error('Failed to resume audio context:', err);
                });
            }
        }
    }

    // Unified audio setup function
    function setupRemoteAudio(stream) {
        try {
            // Clean up any existing audio element
            cleanupAudioElement();

            // Create new audio element
            remoteAudioElement = document.createElement('audio');
            remoteAudioElement.id = "callAudio";

            // Important attributes for Safari
            remoteAudioElement.autoplay = true;
            remoteAudioElement.setAttribute('playsinline', ''); // Critical for Safari

            // Set the stream
            remoteAudioElement.srcObject = stream;

            // Add to document (required for some browsers)
            document.body.appendChild(remoteAudioElement);

            // Store reference globally
            window.callAudioElement = remoteAudioElement;

            // Handle audio output device
            const callAudio = store.getState().toolbar.callAudoSkinId;
            if (remoteAudioElement.setSinkId && callAudio && callAudio.deviceId) {
                remoteAudioElement.setSinkId(callAudio.deviceId).then((resp) => {
                    console.log("setSinkId success", callAudio);
                }).catch((error) => {
                    console.error("setSinkId error", error);
                });
            }

            // Ensure playback starts (with Safari autoplay handling)
            const playPromise = remoteAudioElement.play();
            if (playPromise !== undefined) {
                playPromise.then(() => {
                    Logger.info('Audio playback started successfully');
                }).catch(error => {
                    Logger.error('Audio playback failed:', error);
                    // Retry play after a short delay
                    setTimeout(() => {
                        remoteAudioElement.play().catch(e => {
                            Logger.error('Retry play failed:', e);
                        });
                    }, 100);
                });
            }

            // Add event listeners for debugging
            remoteAudioElement.addEventListener('loadedmetadata', () => {
                Logger.info('Audio metadata loaded');
            });

            remoteAudioElement.addEventListener('canplay', () => {
                Logger.info('Audio can play');
            });

            remoteAudioElement.addEventListener('playing', () => {
                Logger.info('Audio is playing');
            });

            remoteAudioElement.addEventListener('error', (e) => {
                Logger.error('Audio element error:', e);
            });

        } catch (error) {
            Logger.error('Failed to setup remote audio:', error);
        }
    }

    // Cleanup audio element
    function cleanupAudioElement() {
        if (remoteAudioElement) {
            remoteAudioElement.pause();
            remoteAudioElement.srcObject = null;
            if (remoteAudioElement.parentNode) {
                remoteAudioElement.parentNode.removeChild(remoteAudioElement);
            }
            remoteAudioElement = null;
        }
    }

    services.sipAccept = function (onchange = false, disableButton) {
        if (services.isSIPEnabled) {
            ensureAudioContextActive();

            var options = {
                'extraHeaders': ['X-Foo: foo', 'X-Bar: bar'],
                'mediaConstraints': { 'audio': true, 'video': false },
                'pcConfig': { rtcpMuxPolicy: "negotiate" },
                'rtcOfferConstraints': {
                    offerToReceiveAudio: 1,
                    offerToReceiveVideo: 0
                }
            };
            Logger.info('[WebRTC]', 'sipAccept called: call exists=' + !!call + ' call.status=' + (call ? call.status : 'N/A'));
            if (call && typeof call != "undefined" && call.status === 4) {
                try {
                    call.answer(options);
                    Logger.info('[WebRTC]', 'call.answer() executed successfully');
                    onchange && disableButton();
                } catch (e) {
                    Logger.error('[WebRTC]', 'call.answer() threw an error:', e.message, e);
                }
            } else {
                Logger.warn('[WebRTC]', 'sipAccept skipped: call=' + !!call + ' status=' + (call ? call.status : 'N/A') + ' (expected status 4)');
            }
        }
    }
    services.sipDecline = function () {
        if (services.isSIPEnabled) {
            if (call && typeof call != "undefined" && (call.status === 4 || call.status === 5 || call.status === 9)) {
                try {
                    call.terminate();
                } catch (e) {
                    Logger.error('[WebRTC]','call.terminate() threw an error', e);
                }
            }
        }

    }
    services.resetSIP = function () {
        if (services.isSIPEnabled) {
            if (agentSIP) {
                agentSIP.stop();
                agentSIP.start();
            } else {
                services.loadSIP();
            }
        }
    }
    
    services.stopSIP = function () {
        if (services.isSIPEnabled && agentSIP) {
            // console.log("Stopping SIP connection...");
            agentSIP.stop();
        }
    }
    services.clearSIP = function () {
        if (agentSIP) {
            console.log("Clearing SIP instance...");
            agentSIP.removeAllListeners();
            agentSIP = null;
        }
    };

    services.isRegistered = function () {
        if (agentSIP && agentSIP.isRegistered()) {
            return true;
        } else {
            return false;
        }
    };

    services.sendDTMF = function (value) {
        if (services.isSIPEnabled) {
            if (typeof call !== "undefined") {
                call.sendDTMF(value);
            } else {
                 Logger.error('[WebRTC]','SIP call object not found');
            }
        }
    }

    // Add method to manually refresh audio devices (for use with a button if needed) 
    services.refreshAudioDevices = function () {
        if (audioDeviceHandler) {
            audioDeviceHandler.refreshAudioDevices();
        }
    }

    function setRingtone(state) {
        if (!callRing) {
            callRing = document.getElementById('ringAudio')
        }
        if (callRing !== undefined && callRing !== null) {
            if (state) {
                callRing.pause();
            } else {
                callRing.play()
            }
        }
    }

    function setCallanweredBeep() {
        if (!callAnsweredBeep) {
            callAnsweredBeep = document.getElementById('beepAudio')
        }
        callAnsweredBeep.play();
    }

    function setSdp(body) {
        var lbody = body.split("\n");
        var tempbody;
        var removedLines = [];
        for (var i = 0; i < lbody.length; i++) {
            if (!lbody[i].indexOf("a=crypto:1")) {
                removedLines.push(lbody[i].trim());
                continue;
            }
            if (!tempbody) {
                tempbody = lbody[i];
            } else {
                tempbody += "\n" + lbody[i];
            }
        }
        if (removedLines.length > 0) {
            Logger.info('[WebRTC]', 'setSdp removed ' + removedLines.length + ' crypto line(s): ' + removedLines.join(' | '));
        } else {
            Logger.info('[WebRTC]', 'setSdp: no crypto lines removed');
        }
        return tempbody;
    }

    return services;
}());

export default sipService;

function handlesipConnection() {
    store.dispatch(setSIPConnectionStatus(true));
    store.dispatch(setSipDisconnectPause(false));
    store.dispatch(setSIPConnectingStatus(false));
    stopSipReconnectRetry();
    changeAgentStatusToReady();
}
const changeAgentStatusToReady = () => {
    const isCallEnded = store.getState().call.isCallEnded;
    const isComponentOnCall = store.getState().call.isComponentOnCall;
    const isCallAttended = store.getState().call.isCallAttended;
    let pauseReason = store.getState().timer.pauseReason;
    const isCallInComming = store.getState().timer.isCallIncomming;
    const isChatsAvl = isChatsPresent();
    const mode = store.getState().toolbar.agent.mode;
    const ROLE_CHAT_CALL = getRoleStatus('ROLE_CHAT_CALL');

    if (!isCallEnded && !isComponentOnCall &&
        !isCallAttended && !isCallInComming &&
        pauseReason !== "" && (pauseReason?.reason.includes("SIP disconnected") || pauseReason?.reason.includes("SIP UnRegistered"))) {
        console.log("!isCallattende,!isComponentOnCall,!isCallAttended,!isCallInComming", !isCallEnded, !isComponentOnCall, !isCallAttended, !isCallInComming);
        console.log("pause reason ", pauseReason?.reason)
        if (mode === MODES.DIGITAL || (!ROLE_CHAT_CALL && mode === MODES.BELNDED)) {
            if (!isChatsAvl) {
                console.log("sip connected,ROLE_CHAT_CALL(false) or mode digital and no chats are avl, so releasing agent")
                releaseAgent();
            }
        } else {
            releaseAgent();
        }
    }
}

let sipReconnectTimer = null;
export function stopSipReconnectRetry() {
    if (sipReconnectTimer) {
        clearInterval(sipReconnectTimer);
        sipReconnectTimer = null;
    }
}

function attemptSipReconnect() {
    const isSIPconnected = store.getState().toolbar.isSIPconnected;
    const sipDisconnectPause = store.getState().toolbar.sipDisconnectPause;
    if (isSIPconnected) {
        Logger.info('[WebRTC]', 'Stopping SIP auto-reconnect retry (already connected or pause resolved)');
        stopSipReconnectRetry();
        return;
    }
    const isComponentOnCall = store.getState().call.isComponentOnCall;
    const isCallAttended = store.getState().call.isCallAttended;
    const isCallInComming = store.getState().timer.isCallIncomming;
    if (isComponentOnCall || isCallAttended || isCallInComming) {
        Logger.info('[WebRTC]', 'Skipping SIP auto-reconnect attempt - agent on a call');
        return;
    }
    if (!navigator.onLine) {
        Logger.info('[WebRTC]', 'Skipping SIP auto-reconnect attempt - no internet connection');
        return;
    }
    if (!WSocketService.isSocketConnected(false)) {
        Logger.info('[WebRTC]', 'Skipping SIP auto-reconnect attempt - websocket not connected');
        return;
    }
    Logger.info('[WebRTC]', 'SIP auto-reconnect attempt: calling');
    sipService.resetSIP();
}

function startSipReconnectRetry() {
    if (sipReconnectTimer) return;
    if (!isSettingEnabled('SIP_AUTO_RECONNECT')) {
        // Logger.info('Not starting SIP auto-reconnect retry - SIP_AUTO_RECONNECT setting disabled');
        return;
    }
    if (!navigator.onLine || !WSocketService.isSocketConnected(false)) {
        Logger.info('[WebRTC]', 'Not starting SIP auto-reconnect retry - internet/websocket not connected');
        return;
    }
    Logger.info('[WebRTC]', 'Starting SIP auto-reconnect retry (every 30s)');
    // attemptSipReconnect();
    sipReconnectTimer = setInterval(attemptSipReconnect, 30000);
}

export async function handleSipDisconnect(type) {
    // Logger.info('[WebRTC]', 'SIP Disconnected');
    setTimeout(async () => {
        const isCallEnded = store.getState().call.isCallEnded;
        const isComponentOnCall = store.getState().call.isComponentOnCall;
        const isCallAttended = store.getState().call.isCallAttended;
        const isCallInComming = store.getState().timer.isCallIncomming || false;
        const agentState = store.getState().toolbar.agent.state;
        let SOFT_PHONE_FOR_SIP = store.getState().toolbar.params.SOFT_PHONE_FOR_SIP;
        let pauseReason = store.getState().timer.pauseReason;
        Logger.info('[WebRTC]', `SIP event states: SOFT_PHONE_FOR_SIP=${SOFT_PHONE_FOR_SIP}, pauseReason=${pauseReason}, isCallEnded=${isCallEnded}, isComponentOnCall=${isComponentOnCall}, isCallAttended=${isCallAttended}, isCallInComming=${isCallInComming}, agentState=${agentState}`);
        if ((SOFT_PHONE_FOR_SIP === undefined || (SOFT_PHONE_FOR_SIP && SOFT_PHONE_FOR_SIP !== "true")) &&
            (pauseReason === "" || pauseReason === null) && !isCallEnded) {
            const isSIPconnected = store.getState().toolbar.isSIPconnected;
            const isSip = store.getState().toolbar.loginDetails.isSip;
            const sipDisconnectPause = store.getState().toolbar.sipDisconnectPause;
            Logger.info('[WebRTC]', `SIP event states_1: isSIPconnected=${isSIPconnected}, isSip=${isSip}, sipDisconnectPause=${sipDisconnectPause}`);
            if (!isSIPconnected && isSip && !sipDisconnectPause && !isComponentOnCall && !isCallAttended && !isCallInComming && agentState !== AGENT_STATE.NOT_READY) {
                const temp = {
                    reason: type ? type : "SIP disconnected",
                    timeLimit: 0
                };
                store.dispatch(setPauseReason(temp));
                await pauseAgent(temp);
                store.dispatch(setSipDisconnectPause(true));
            }
        }
    }, 1000);

}
export function handleSipAutoAnswer(showMessage) {
    let agentInfo = store.getState().toolbar.loginDetails.agentInfo;
    let callDetails = store.getState().call.callDetails;
    let msg = "SIP is available to answer, the call will be auto answered";
    Logger.info('[WebRTC]', 'handleSipAutoAnswer: callType=' + callDetails?.callType + ' hasAutoAnswer=' + agentInfo?.hasOwnProperty('autoAnswer') + ' rawValue=' + agentInfo?.autoAnswer);
    if (agentInfo.hasOwnProperty('autoAnswer')) {
        let autoAnswer = agentInfo.autoAnswer;
        switch (autoAnswer) {
            case 0: autoAnswer = "none"; break;
            case 1: autoAnswer = "all"; break;
            case 2: autoAnswer = "inbound"; break;
            case 3: autoAnswer = "outbound"; break;
            default: autoAnswer = "none"; break;
        }
        Logger.info('[WebRTC]', 'handleSipAutoAnswer: resolved autoAnswer=' + autoAnswer);
        if (autoAnswer === 'all') {
            Logger.info('[WebRTC]', 'Auto answer triggered: ALL');
            showMessage && showInfoNotification(msg);
            sipService.sipAccept();
        } else if (autoAnswer === 'inbound' && callDetails && callDetails.callType && callDetails.callType.toLowerCase().indexOf("incoming") !== -1) {
            Logger.info('[WebRTC]', 'Auto answer triggered: INBOUND');
            showMessage && showInfoNotification(msg);
            sipService.sipAccept();
        } else if (autoAnswer === 'outbound' && callDetails && callDetails.callType && callDetails.callType.toLowerCase().indexOf("incoming") === -1) {
            Logger.info('[WebRTC]', 'Auto answer triggered: OUTBOUND');
            showMessage && showInfoNotification(msg);
            sipService.sipAccept();
        } else if (callDetails && callDetails.callType && (callDetails.callType.toLowerCase() === 'manual dialing' ||
            callDetails.callType.toLowerCase() === 'callbackdial')) {
            Logger.info('[WebRTC]', 'Auto answer triggered: Manual Dialing / CallbackDial');
            showMessage && showInfoNotification(msg);
            sipService.sipAccept();
        } else {
            Logger.info('[WebRTC]', 'Auto answer not triggered: autoAnswer=' + autoAnswer + ' callType=' + callDetails?.callType + ' — waiting for manual answer');
            showMessage && showInfoNotification("SIP call is available to answer, please click on answer button");
        }
    }
}
